// extracted by mini-css-extract-plugin
export default {"base":"AnchorButton_base__6Kq9G","primary":"AnchorButton_primary__rCDYT"};